import { create } from "zustand";
import Cookies from "js-cookie";
import { axiosInstance } from "../lib/axios";
import { useNavigate } from "react-router-dom";
import { deleteOrder, dowloadOrderDetailFunction, dowloadorderlist, getAllOrderFunction, getOrderById, updateOrderById } from "../api/order";



export const useOrderStore = create((set, get) => ({
    order: [],
    loading: false,

    getAllOrder: async (pageNumber, pageSize, search, field, dateRange) => {
        set({ loading: true })
        try {
            const res = await getAllOrderFunction(pageNumber, pageSize, search, field, dateRange)
            console.log("getAllCategory", res)
            set({ loading: false, order: res?.ref })
            return res
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    },
    getRecentOrder: async (pageNumber, pageSize, search, field, dateRange) => {
        set({ loading: true })
        try {
            const res = await getAllOrderFunction(pageNumber, pageSize, search, field, dateRange)
            set({ loading: false })
            return res?.ref
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    },
    getOrderById: async (id) => {
        set({ loading: true })
        try {
            const res = await getOrderById(id)
            set({ loading: false })
            return res
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    },
    updateOrderStatus: async (id, orderStatus) => {
        set({ loading: true })
        try {
            const res = await updateOrderById(id, orderStatus)
            set({ loading: false })
            return res
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    },
    deleteorder: async (id) => {
        try {
            set({ loading: true })
            const res = await deleteOrder(id)
            const currentOrder = get().order || [];
            const updatedOrder = currentOrder.filter((ele) => ele._id !== id);
            set({ loading: false, order: updatedOrder });
        } catch (err) {
            console.log("Internal server error:", err);
            set({ category: null });
            return false;
        }
    },
    dowloadOrderDetail: async (id) => {
        try {
            set({ loading: true })
            const res = await dowloadOrderDetailFunction(id)
            set({ loading: false });
        } catch (err) {
            console.log("Internal server error:", err);
            set({ category: null });
            return false;
        }
    },
    dowloadOrderList: async (pageNumber, pageSize, search, field) => {
        try {
            set({ loading: true })
            const res = await dowloadorderlist(pageNumber, pageSize, search, field)
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Internal server error:", error);
            set({ category: null });
            return false;
        }
    },

}))

